import { Component } from '@angular/core';
import { NotificationsService} from '@westjetairlines/wjesd-component-library';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor( private router: Router, private notificationService: NotificationsService) {

    router.events.subscribe( (event) => {

      if (event instanceof NavigationStart) {
        notificationService.clear();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts